import { render, staticRenderFns } from "./purchaseCardGallery.vue?vue&type=template&id=05cde635"
import script from "./purchaseCardGallery.vue?vue&type=script&lang=js"
export * from "./purchaseCardGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports